import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { filterColumnAction } from "../../axios/authKey";
/**
 * 解决table中 由于权限按钮导致 操作列有可能为空且占位的问题
 * @param actionKeyList 权限集合 [string]
 *
 * @class AuthTable
 * @extends {React.Component}
 */
class AuthTable extends React.Component {
    render() {
        const columns = filterColumnAction(
            this.props.children.props.columns,
            this.props.actionKeyList,
            this.props.AuthConfig,
            "action"
        );

        return <div>{React.cloneElement(this.props.children, { columns })}</div>;
    }
}
const mapStateToProps = state => {
    const AuthConfig = state.config.auth;
    return { AuthConfig };
};
AuthTable.propTypes = {
    actionKeyList: PropTypes.array
}


export default connect(mapStateToProps)(AuthTable);



// WEBPACK FOOTER //
// ./src/components/AuthTable/index.js